export const MESSAGES_PUSH_TOAST_MESSAGE = 'MESSAGES_PUSH_TOAST_MESSAGE';
export const MESSAGES_SHIFT_TOAST_MESSAGE = 'MESSAGES_SHIFT_TOAST_MESSAGE';
export const MESSAGES_RESET_STATE = 'MESSAGES_RESET_STATE';
export const MESSAGES_UPDATE_HEADER_MESSAGE = 'MESSAGES_UPDATE_HEADER_MESSAGE';
